<div class="video-page-container">
    <div class="video-wrapper">
      <video #videoPlayer width="100%" autoplay height="100%" controls>
        <p>{{'Your browser does not support the video tag' | translate}}</p>
      </video>
      <div *ngIf="videoLoading" class="loading-overlay">
        {{'Waiting for the stream to start...' | translate}}
      </div>
    </div>
</div>
